import { render, staticRenderFns } from "./FeaturedFunnel.vue?vue&type=template&id=9fa4a3fc"
import script from "./FeaturedFunnel.vue?vue&type=script&lang=js"
export * from "./FeaturedFunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports